<template>
    <div>
        <div v-if="!creating" class="new-ask-button-container">
            <b-button
                variant="link"
                class="ask-container"
                @click="toggleCreate()"
            >
                <span>{{ $t('talk.form.addQuestion') }}</span>
            </b-button>
        </div>
        <Form @cancel="toggleCreate()" @save="saveAsk" v-if="creating" />
    </div>
</template>

<script>
import { createAsk } from './api'

import notification, { success, danger } from '@/lib/notification'

import { Form } from './components'

notification.init()

export default {
    name: 'NewAsk',
    components: {
        Form,
    },
    props: {
        templateId: {
            required: true,
            type: Number | null,
        },
    },
    data() {
        return {
            creating: false,
        }
    },
    methods: {
        toggleCreate() {
            this.creating = !this.creating
        },
        saveAsk(title) {
            const newAsk = {
                title,
                template_id: this.templateId,
            }
            this.creating = false
            createAsk(newAsk)
                .then(ask => {
                    this.$emit('created', ask)
                    success(
                        this.$t('notification.createdSuccessfully', {
                            item: this.$t('talk.ask'),
                        })
                    )
                })
                .catch(e => {
                    console.log(e)
                    danger()
                })
        },
    },
}
</script>

<style lang="sass" scoped>
.new-ask-button-container
    display: flex
    justify-content: center
    .ask-container
        display: flex
        justify-content: center
        align-items: center
        padding: 10px 20px
        border-radius: 6px
        font-size: 13px
        width: 20%
        min-height: 50px
        min-width: 300px
        cursor: pointer
</style>
